import { Outlet, useNavigate } from 'react-router-dom';

import AddonGateModal from '#globalComponents/addons/AddonGateModal';
import { CRM_ADDON } from '#lib/addons/addonConfigs';

import AircallCallOverlay from '../../components/aircallEverywhere/AircallCallOverlay';
import AircallEverywhereProvider from '../../components/aircallEverywhere/AircallEverywhereProvider';
import AircallPhoneWidget from '../../components/aircallEverywhere/AircallPhoneWidget';
import PowerDialer from '../../components/dialer/PowerDialer/PowerDialer';
import { usePowerDialerStore } from '../../stores/powerDialerStore';

/**
 * CrmShell is the layout wrapper for all /crm/* routes. It hosts the overlays
 * that must persist across CRM pages (Power Dialer, Aircall, add-on gate modal).
 */

const CrmShell = () => {
	const navigate = useNavigate();

	const dialerActive = usePowerDialerStore((s) => s.active);
	const dialerQueue = usePowerDialerStore((s) => s.queue);
	const dialerMinimized = usePowerDialerStore((s) => s.minimized);
	const stopDialer = usePowerDialerStore((s) => s.stop);
	const minimizeDialer = usePowerDialerStore((s) => s.minimize);
	const restoreDialer = usePowerDialerStore((s) => s.restore);

	return (
		<AircallEverywhereProvider>
			<div className="h-full">
				<AddonGateModal addon={CRM_ADDON} />
				<Outlet />

				{dialerActive && (
					<PowerDialer
						queue={dialerQueue}
						minimized={dialerMinimized}
						onMinimize={minimizeDialer}
						onRestore={restoreDialer}
						onClose={stopDialer}
						onOpenDeal={(companyId) => navigate(`/crm/companies/${companyId}`)}
					/>
				)}

				<AircallCallOverlay />
				<AircallPhoneWidget />
			</div>
		</AircallEverywhereProvider>
	);
};

export default CrmShell;
